import type { StateCreator } from 'zustand'

/** Toggles the IFC diff panel rendered above the canvas. The diff
 * itself lives in component state; we only persist the open/closed
 * flag here so other UI (toolbar button highlight) can reflect it. */
export interface IfcDiffSlice {
  ifcDiffOpen: boolean
  setIfcDiffOpen: (open: boolean) => void
}

export const createIfcDiffSlice: StateCreator<IfcDiffSlice> = (set) => ({
  ifcDiffOpen: false,
  setIfcDiffOpen: (open) => set({ ifcDiffOpen: open }),
})
